import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalculationResult } from '../../models/calculationModels';
import {
    BoltDetails,
    ClampDataSheet,
    DataSheetReport,
    EngineeredJointDataSheet,
    ProjectDetails,
    TensionDetailsDataSheet,
    TighteningValues,
    TorqueDetailsDataSheet,
    Traceability,
} from '../../models/reports/data-sheet-report.model';
import {
    JointCompletionCertificate,
    JointIdDetails,
    ProjectDetailJCC,
    StandardOrCustomFlangeDetail,
    TensionDetails,
    TorqueDetails,
    TraceabilityDetailsJCC,
    Values,
} from '../../models/reports/joint-completion-certificate.model';
import { CreateDataSheetReportComponent } from '../create-data-sheet-report/create-data-sheet-report.component';
import { JointCompletionReportComponent } from '../joint-completion-report/joint-completion-report.component';
import { UserDefaultModel } from './../../../../models/user-default-model';
import { GlobalEmittersService } from './../../../../services/global-emitters.service';
import { ManagementApiService } from './../../../../services/management-api.service';
import { ClampJCC, EngineeredJointJCC } from './../../models/reports/joint-completion-certificate.model';

@Component({
    selector: 'app-reports-dropdown',
    templateUrl: './reports-dropdown.component.html',
    styleUrls: ['./reports-dropdown.component.scss'],
    standalone: false
})
export class ReportsDropdownComponent implements OnInit {
    @Input() calculationResult: CalculationResult;
    dataSheetReport = new DataSheetReport();
    jccReport = new JointCompletionCertificate();

    /**
     * properties for JCC reports
     */
    jccProject: ProjectDetailJCC;
    jccJointIdDetails: JointIdDetails;
    standardOrCustomFlangeDetail: StandardOrCustomFlangeDetail;
    jccClamp: ClampJCC;
    jccEngineeredJoint: EngineeredJointJCC;
    jccValues: Values;
    jccTension: TensionDetails;
    jccTorque: TorqueDetails;
    jccTraceability: TraceabilityDetailsJCC;

    /**
     * properties for DataSheetReport
     */
    dsrProjectDetails: ProjectDetails;
    dsrTraceability: Traceability;
    dsrTighteningValues: TighteningValues;
    dsrTension: TensionDetailsDataSheet;
    dsrTorque: TorqueDetailsDataSheet;
    dsrBoltDetails: BoltDetails;
    dsrClamp: ClampDataSheet;
    dsrEngineeredJoint: EngineeredJointDataSheet;
    userDefaults: UserDefaultModel[];
    constructor(
        private modalService: NgbModal,
        private globalEmittersService: GlobalEmittersService,
        private managementApiService: ManagementApiService
    ) {
        this.standardOrCustomFlangeDetail = new StandardOrCustomFlangeDetail();
        this.jccClamp = new ClampJCC();
        this.jccProject = new ProjectDetailJCC();
        this.jccJointIdDetails = new JointIdDetails();
        this.jccValues = new Values();
        this.jccTension = new TensionDetails();
        this.jccTorque = new TorqueDetails();
        this.jccTraceability = new TraceabilityDetailsJCC();
        // this.getCommonValuesForJCCReport();
        this.dsrProjectDetails = new ProjectDetails();
        this.dsrTraceability = new Traceability();
        this.dsrBoltDetails = new BoltDetails();
        this.dsrTighteningValues = new TighteningValues();
        this.dsrTension = new TensionDetailsDataSheet();
        this.dsrTorque = new TorqueDetailsDataSheet();
        this.dsrClamp = new ClampDataSheet();
        this.dsrEngineeredJoint = new EngineeredJointDataSheet();
    }

    ngOnInit(): void {
        this.globalEmittersService.isUserDefaultsLoaded.subscribe((res) => {
            if (res) {
                this.userDefaults = this.managementApiService.userDefaults;
            }
        });
    }

    openCreateDataSheetModal() {
        let dialogRef = this.modalService.open(CreateDataSheetReportComponent, {
            ariaLabelledBy: 'modal-basic-title',
            backdrop: 'static',
            size: 'md',
            keyboard: false,
        });
        dialogRef.componentInstance.dataSheetReport = this.dataSheetReport;
        dialogRef.componentInstance.calculationResult = this.calculationResult;
    }

    openJointCompletionReport() {
        let dialogRef = this.modalService.open(JointCompletionReportComponent, {
            ariaLabelledBy: 'modal-basic-title',
            backdrop: 'static',
            size: 'lg',
            // keyboard: false
        });
        dialogRef.componentInstance.calculationResult = this.calculationResult;
    }
}
